import { Box, Button, Container, Stack, Typography, styled } from '@mui/material';
import React from 'react';

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.common.white,
}));

const FaqTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 600,
  fontSize: '2.25rem',
  color: '#181D27',
  textAlign: 'center',
  marginBottom: theme.spacing(2),
}));

const FaqDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  color: '#535862',
  textAlign: 'center',
  maxWidth: '800px',
  margin: '0 auto',
  marginBottom: theme.spacing(8),
}));

const ContactCardWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(157, 21, 0, 0.02)',
  border: '1px solid rgba(157, 21, 0, 0.2)',
  borderRadius: '16px',
  padding: theme.spacing(4, 4, 5),
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

const AvatarGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  '& img': {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    border: `1.5px solid ${theme.palette.common.white}`,
    '&:not(:first-of-type)': {
      marginLeft: '-10px',
    },
  },
}));

const ContactTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 600,
  fontSize: '1.25rem',
  color: '#181D27',
}));

const ContactDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#535862',
  maxWidth: '500px',
  margin: '0 auto',
}));

const GetInTouchButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: '8px',
  fontWeight: 600,
  padding: '12px 18px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const HaveQuestionsSection: React.FC = () => (
  <SectionWrapper>
    <Container maxWidth="lg">
      <FaqTitle>Frequently asked questions</FaqTitle>
      <FaqDescription>
        Everything you need to know about the Terra.AI and how to join.
      </FaqDescription>

      <Box sx={{ mb: 8 }}>
        {/* FAQ content goes here - would be implemented with Accordion from MUI */}
      </Box>

      <ContactCardWrapper>
        <AvatarGroup>
          <img src="/assets/images/aboutus/avatar1.png" alt="Team member" />
          <img src="/assets/images/aboutus/avatar2.png" alt="Team member" />
          <img src="/assets/images/aboutus/avatar3.png" alt="Team member" />
        </AvatarGroup>

        <Stack spacing={1}>
          <ContactTitle>Still have questions?</ContactTitle>
          <ContactDescription>
            Can't find the answer you're looking for? Please chat to our friendly team.
          </ContactDescription>
        </Stack>

        <GetInTouchButton href="mailto:hello@terr.ai">Get in touch</GetInTouchButton>
      </ContactCardWrapper>
    </Container>
  </SectionWrapper>
);

export default HaveQuestionsSection;
